// utils/staffCookie.ts — penanda login lintas-subdomain untuk presence.
// Masalah: sesi Supabase di localStorage terikat 1 origin — admin/CS login di
// admin.* TAK terlihat dari form.*/lp.*/domain merchant → ikut kehitung pengunjung
// walau shouldTrackPresence sudah ada (insiden 2026-10-22).
// Solusi: cookie cm_staff=1 domain=.cuanmax.digital saat login; tracker publik cek
// cookie DULU (sinkron, tanpa network) sebelum cek sesi. Kadaluarsa 7 hari agar
// cookie basi (logout di tab lain) pulih sendiri. Domain merchant custom tak
// tercakup (cookie tak bisa lintas domain) — keterbatasan wajar.
export const STAFF_COOKIE = 'cm_staff';
const MAX_AGE = 7 * 24 * 3600;

/** Domain cookie utk hostname tsb, atau null = host-only (localhost/IP/custom). */
export function cookieDomainFor(hostname: string): string | null {
  const h = (hostname || '').toLowerCase().trim();
  if (!h || h === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(h) || h.includes(':')) return null;
  if (h === 'cuanmax.digital' || h.endsWith('.cuanmax.digital')) return '.cuanmax.digital';
  return null;
}

/** Parse mentah header cookie — murni (bisa di-unit-test tanpa DOM). */
export function parseStaffCookie(header: string): boolean {
  return String(header || '').split(';').some(c => c.trim() === `${STAFF_COOKIE}=1`);
}

export function markStaffSession(): void {
  try {
    const domain = cookieDomainFor(window.location.hostname);
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${STAFF_COOKIE}=1; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${domain ? `; Domain=${domain}` : ''}${secure}`;
  } catch { /* private mode — gate sesi tetap jalan */ }
}

export function clearStaffSession(): void {
  try {
    const domain = cookieDomainFor(window.location.hostname);
    const base = `${STAFF_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
    document.cookie = base;
    if (domain) document.cookie = `${base}; Domain=${domain}`;
  } catch {}
}

export function hasStaffCookie(): boolean {
  try {
    return typeof document !== 'undefined' && parseStaffCookie(document.cookie);
  } catch {
    return false;
  }
}
